import type { DealCard } from '@/app/components/search/utils/buildDealCards/dealCardTypes.ts';

export enum BADGE_SLOTS {
  DEAL_HIGHLIGHTS = 'deal-highlights',
  PRICE_ADDONS = 'price-addons',
  GALLERY_OVERLAY = 'gallery-overlay',
  GALLERY_OVERLAY_OLD = 'gallery-overlay-tsx',
  HOTEL_HEADER = 'hotel-header',
}

export type BadgeContext = {
  dealCard: DealCard;
  isOverlay?: boolean;
  remainingSlots?: number;
};
